import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";


@Component({
    selector: 'page-geis-admission-report',
    templateUrl: 'geis-admission-report.html',
})
export class GeisAdmissionReportPage {

    TotalAdm: any;
    ContinueAdm: any;
    NewAdm: any;
    NotContinueAdm: any;

    constructor(public navCtrl: NavController,
                public service: ServiceProvider,
                public viewCtrl: ViewController,
                public loadingCtrl: LoadingController,
                public platform: Platform,
                public navParams: NavParams) {

        this.platform.ready().then(() => {
            this.loadvalues();
        });

    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad GetContinueAdmissionsPage');
    }

    loadvalues() {

        this.TotalAdm = [];
        this.ContinueAdm = [];
        this.NewAdm = [];
        this.NotContinueAdm = [];

        let loading = this.loadingCtrl.create({
            content: 'Please wait...'
        });

        loading.present();

        this.service.httpcall('app_web_service/get_total_admission_report?').subscribe(data => {

            this.TotalAdm = data;
            console.log('TotalAdm', this.TotalAdm);
            loading.dismiss();
        }),
            this.service.httpcall('app_web_service/get_continue_admissions_report?').subscribe(data => {

                this.ContinueAdm = data;
                console.log('AdminReport', this.ContinueAdm);
                loading.dismiss();
            }),
            this.service.httpcall('app_web_service/get_New_admissions_report?').subscribe(data => {

                this.NewAdm = data;
                console.log('NewAdm', this.NewAdm);
                loading.dismiss();
            }),
            this.service.httpcall('app_web_service/get_left_admissions_report?').subscribe(data => {

                this.NotContinueAdm = data;
                console.log('NotContinueAdm', this.NotContinueAdm);
                loading.dismiss();
            })

    }

    doRefresh(refresher) {
        console.log('Begin async operation', refresher);

        this.loadvalues();

        setTimeout(() => {
            console.log('Async operation has ended');

            refresher.complete();
        }, 2000);
    }

    backBTN() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/geis-admission-report/geis-admission-report.ts